<template>
  <div>
    <h6>{{ type }}</h6>
    <div>
      <div class="left p-4"></div>
      <div class="divider"></div>
      <div class="right p-4 d-flex align-items-center justify-content-between">
        <div class="details">
          <p class="name"></p>
          <p
            class="adv px-2 py-1 rounded font12 fw700"
            :style="{
              background: getAlphaPrimaryColor(),
              color: getPrimaryColor(),
            }"
            v-if="type === 'Advocates'"
          >
            Advocate for Colon Cancer
          </p>
          <p class="loc">
            <font-awesome-icon size="1x" class="mr-2" :icon="['fal', 'map-marker-alt']" />
            Brooklyn, NY 934 Manhattan Ave
          </p>
          <p class="members">0 circle members</p>
        </div>
        <div class="btn font14 fw7000 font-white py-2 px-3" :style="{ background: getPrimaryColor() }">View Profile</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SPeople",
  props: { type: String },
  data() {
    return { peopleList: [] }
  },
  mounted() {},
}
</script>

<style lang="scss" scoped>
p {
  margin-bottom: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/home/search/SPeople.vue